import React, { useState, useEffect } from 'react';
import s from './Horarios.module.css';
import { Btn } from '../UI/Btn';
import { Icons } from '../Sidebar/Icons';
import { useStore } from '../../hooks/useStore';
import { store } from '../../utils/store';
import { fmtDate } from '../../utils/helpers';

const DIAS = [
  ['seg', 'Segunda-feira'],
  ['ter', 'Terça-feira'],
  ['qua', 'Quarta-feira'],
  ['qui', 'Quinta-feira'],
  ['sex', 'Sexta-feira'],
  ['sab', 'Sábado'],
  ['dom', 'Domingo'],
];

// Migra qualquer formato antigo para { seg: { ativo: true, horarios: ['09:00',...] }, ... }
function migrar(horarios) {
  const r = {};
  DIAS.forEach(([k]) => {
    const val = horarios?.[k];
    if (val && typeof val === 'object' && !Array.isArray(val) && 'ativo' in val) {
      // já no novo formato
      r[k] = { ativo: !!val.ativo, horarios: Array.isArray(val.horarios) ? val.horarios : [] };
    } else if (Array.isArray(val) && val.every(v => typeof v === 'string')) {
      r[k] = { ativo: val.length > 0, horarios: val };
    } else if (val === true) {
      // formato legado boolean
      const slots = [];
      const ini = horarios.ini || '09:00';
      const fim = horarios.fim || '18:00';
      const [hI, mI] = ini.split(':').map(Number);
      const [hF, mF] = fim.split(':').map(Number);
      let c = hI * 60 + mI;
      while (c <= hF * 60 + mF) {
        slots.push(`${String(Math.floor(c / 60)).padStart(2, '0')}:${String(c % 60).padStart(2, '0')}`);
        c += 30;
      }
      r[k] = { ativo: true, horarios: slots };
    } else {
      r[k] = { ativo: false, horarios: [] };
    }
  });
  return r;
}

export function Horarios() {
  const { horarios, diasBloqueados } = useStore();
  const [grade, setGrade] = useState(() => migrar(horarios));
  const [novoHorario, setNovoHorario] = useState({});  // { seg: '07:00', ter: '', ... }
  const [salvando, setSalvando] = useState(false);
  const [salvoOk, setSalvoOk] = useState(false);
  const [novas, setNovas] = useState(['']);

  useEffect(() => {
    setGrade(migrar(horarios));
  }, [JSON.stringify(horarios)]);

  // Toggle ativo/inativo do dia
  const toggleDia = (dia) => {
    setGrade(g => ({ ...g, [dia]: { ...g[dia], ativo: !g[dia].ativo } }));
  };

  // Adiciona horário ao dia
  const addHorario = (dia) => {
    const h = (novoHorario[dia] || '').trim();
    if (!h) return;
    if (grade[dia].horarios.includes(h)) {
      setNovoHorario(n => ({ ...n, [dia]: '' }));
      return;
    }
    const novos = [...grade[dia].horarios, h].sort();
    setGrade(g => ({ ...g, [dia]: { ...g[dia], horarios: novos } }));
    setNovoHorario(n => ({ ...n, [dia]: '' }));
  };

  // Remove horário do dia
  const removeHorario = (dia, h) => {
    setGrade(g => ({ ...g, [dia]: { ...g[dia], horarios: g[dia].horarios.filter(x => x !== h) } }));
  };

  // Salva no banco
  const salvar = async () => {
    setSalvando(true);
    try {
      await store.setHorarios(grade);
      setSalvoOk(true);
      setTimeout(() => setSalvoOk(false), 2500);
    } finally {
      setSalvando(false);
    }
  };

  // Dias bloqueados
  const addBloq = async () => {
    const val = novas.filter(d => d.trim());
    if (!val.length) return;
    for (const d of val) await store.addDiaBloqueado(d);
    setNovas(['']);
  };
  const byMes = diasBloqueados.reduce((a, d) => {
    const [y, m] = d.split('-'); const k = `${y}-${m}`;
    if (!a[k]) a[k] = []; a[k].push(d); return a;
  }, {});
  const mesLbl = ym => {
    const [y, m] = ym.split('-');
    return new Date(Number(y), Number(m) - 1).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
  };

  return (
    <div className={s.layout}>

      {/* Horários por dia */}
      <div className={s.card}>
        <div className={s.ch}>
          <Icons.Clock />
          <span>Horários de Atendimento</span>
          <div className={s.chActs}>
            <Btn onClick={salvar} disabled={salvando} size="sm">
              {salvando ? 'Salvando...' : salvoOk ? '✓ Salvo!' : 'Salvar'}
            </Btn>
          </div>
        </div>
        <div className={s.body}>
          <p className={s.hint}>
            Ative os dias que atende e adicione os horários disponíveis. Os horários aparecem para o cliente na ordem que forem adicionados.
          </p>

          <div className={s.grade}>
            {DIAS.map(([dia, lbl]) => {
              const { ativo, horarios: hrs } = grade[dia] || { ativo: false, horarios: [] };
              return (
                <div key={dia} className={`${s.diaCard} ${ativo ? s.diaOn : s.diaOff}`}>

                  {/* Cabeçalho do dia */}
                  <div className={s.diaHead}>
                    <label className={s.diaLabel}>
                      <span className={`${s.toggle} ${ativo ? s.toggleOn : ''}`} onClick={() => toggleDia(dia)}>
                        <span className={s.toggleBall} />
                      </span>
                      <span className={s.diaNome}>{lbl}</span>
                    </label>
                    <span className={ativo ? s.badgeOn : s.badgeOff}>
                      {ativo ? `${hrs.length} horário${hrs.length !== 1 ? 's' : ''}` : 'Fechado'}
                    </span>
                  </div>

                  {/* Horários cadastrados */}
                  {ativo && (
                    <div className={s.diaBody}>
                      <div className={s.hList}>
                        {hrs.length === 0 && (
                          <span className={s.hVazio}>Nenhum horário adicionado</span>
                        )}
                        {hrs.map(h => (
                          <div key={h} className={s.hTag}>
                            <span>{h}</span>
                            <button className={s.hDel} onClick={() => removeHorario(dia, h)}>×</button>
                          </div>
                        ))}
                      </div>

                      {/* Input para adicionar */}
                      <div className={s.addRow}>
                        <input
                          type="time"
                          className={s.timeInput}
                          value={novoHorario[dia] || ''}
                          onChange={e => setNovoHorario(n => ({ ...n, [dia]: e.target.value }))}
                          onKeyDown={e => e.key === 'Enter' && addHorario(dia)}
                        />
                        <button
                          className={s.addBtn}
                          onClick={() => addHorario(dia)}
                          disabled={!novoHorario[dia]}
                        >
                          <Icons.Plus /> Adicionar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Dias bloqueados */}
      <div className={s.card}>
        <div className={s.ch}>
          <Icons.Trash />
          <span>Dias Bloqueados / Feriados</span>
          <span className={s.cnt}>{diasBloqueados.length} dia{diasBloqueados.length !== 1 ? 's' : ''}</span>
        </div>
        <div className={s.body}>
          <p className={s.hint}>Datas bloqueadas ficam indisponíveis no calendário do cliente.</p>
          <div className={s.dl2}>
            {novas.map((d, i) => (
              <div key={i} className={s.dr2}>
                <input type="date" className={s.timeInput} style={{ flex: 1 }} value={d}
                  onChange={e => setNovas(p => p.map((x, j) => j === i ? e.target.value : x))} />
                {novas.length > 1 && (
                  <button className={s.hDel} style={{ width: 32, height: 36, fontSize: 14 }}
                    onClick={() => setNovas(p => p.filter((_, j) => j !== i))}>×</button>
                )}
              </div>
            ))}
          </div>
          <div className={s.btns}>
            <button className={s.addBtnSec} onClick={() => setNovas(p => [...p, ''])}>
              <Icons.Plus /> Adicionar data
            </button>
            <Btn onClick={addBloq}>Bloquear</Btn>
          </div>
          {diasBloqueados.length === 0
            ? <p className={s.nb}>Nenhum dia bloqueado ainda.</p>
            : <div className={s.bg}>
              {Object.entries(byMes).sort().map(([ym, dias]) => (
                <div key={ym}>
                  <div className={s.ml}>{mesLbl(ym)}</div>
                  <div className={s.tgs}>
                    {dias.map(d => (
                      <div key={d} className={s.tgBloq}>
                        <span>{fmtDate(d)}</span>
                        <button className={s.hDel2} onClick={() => store.removeDiaBloqueado(d)}>×</button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </div>

    </div>
  );
}
